(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-image-carousel"] && !Shopify.designMode) return;
  try {
    
  class HsdBlogCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-carousel-track]');
      this.slides = [...root.querySelectorAll('[data-carousel-slide]')];
      this.previous = root.querySelector('[data-carousel-previous]');
      this.next = root.querySelector('[data-carousel-next]');
      this.current = root.querySelector('[data-carousel-current]');

      if (!this.track || this.slides.length < 2) return;

      this.previous?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));

      this.track.addEventListener('scroll', () => {
        window.requestAnimationFrame(() => this.updateCounter());
      });

      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      });

      this.updateCounter();
    }

    activeIndex() {
      const trackLeft = this.track.getBoundingClientRect().left;

      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(
          slide.getBoundingClientRect().left - trackLeft
        );

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    move(direction) {
      let index = this.activeIndex() + direction;

      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.slides[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }

    updateCounter() {
      if (!this.current) return;

      const value = String(this.activeIndex() + 1).padStart(2, '0');
      this.current.textContent = value;
    }
  }

  document
    .querySelectorAll('.hsd-blog-carousel')
    .forEach((carousel) => new HsdBlogCarousel(carousel));

  document.addEventListener('shopify:section:load', (event) => {
    const carousel = event.target.querySelector('.hsd-blog-carousel');

    if (carousel) {
      new HsdBlogCarousel(carousel);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsd-pulse-article"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hsd]').forEach(r=>{let id=r.dataset.hsd,k='hsdv:'+id,c=JSON.parse(localStorage.getItem('hsdc:'+id)||'{"happy":0,"sad":0,"death":0}'),s=r.querySelector('[data-status]'),res=r.querySelector('[data-results]');function draw(){let t=c.happy+c.sad+c.death;['happy','sad','death'].forEach(x=>r.querySelector('[data-p="'+x+'"]').textContent=(t?Math.round(c[x]/t*100):0)+'%');r.querySelector('[data-total]').textContent=t;res.hidden=false}draw();r.querySelectorAll('[data-v]').forEach(b=>{if(localStorage.getItem(k))b.disabled=true;b.onclick=()=>{if(localStorage.getItem(k))return;let v=b.dataset.v;c[v]++;localStorage.setItem('hsdc:'+id,JSON.stringify(c));localStorage.setItem(k,v);r.querySelectorAll('[data-v]').forEach(x=>x.disabled=true);s.textContent='Signal received: '+v.toUpperCase()+'.';draw()}})})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsd-pulse-feed"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-hsd-pulse-feed]').forEach(root=>{const filters=root.querySelectorAll('[data-filter]');const cards=root.querySelectorAll('[data-pulse-card]');filters.forEach(button=>button.addEventListener('click',()=>{filters.forEach(item=>item.classList.remove('is-active'));button.classList.add('is-active');const filter=button.dataset.filter;cards.forEach(card=>{const tags=(card.dataset.tags||'').split(',');card.hidden=filter!=='all'&&!tags.includes(filter)})}))})})();

  } catch(e) { console.error(e); }
})();
})();
